module.exports = __webpack_public_path__ + "img/actionspot.2d00709d.png";